<div class="Header" [ngClass]="{home: isHome}">
    <div class="headerBg"></div>
    <div class="headerWrapper">
        <div class="leftGroup">
            <div class="menuButton" (click)="onToggleDropdown()" [ngClass]="{open: isOpen}">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="logoWrap">
                <div class="logo">
                    <a routerLink="/" class="logoLink">
                        <img src="assets/img/home/lionsgate-channels-title.png" class="normal" *ngIf="!isMobile" alt="">
                        <img src="assets/img/home/lionsgate-channels-title-rollover.png" class="over" *ngIf="!isMobile" alt="">
                        <img src="assets/img/Lionsgate-Channels-top-title.png" *ngIf="isMobile" alt="">
                    </a>
                </div>
            </div>
        </div>

        <div class="buttons" *ngIf="!isMobile">
            <a routerLink="/where-to-watch" class="whereToWatchLink">Where To Watch</a>

            <a (click)="onToggleDropdown()" class="channelsButton" [ngClass]="{open: isOpen}">
                <div class="buttonContent">
                    <div class="arrow"></div>
                    <div class="line"></div>
                    <div class="label">Our Channels</div>
                </div>
            </a>
        </div>

    </div>

    <div class="headerOverlay" [ngClass]="{open: isOpen}" (click)="onClose()"></div>

    <div class="headerDropdown" [ngClass]="{open: isOpen, home: isHome}">
        <button class="closeBtn" (click)="onClose()">&#x2715;</button>

        <div class="dropdownInner"> 

            <!-- Top two-column section -->
            <div class="topSection">

                <!-- Left: FAST Channels -->
                <div class="fastSection">
                    <div class="sectionTitle">Lionsgate Channels</div>
                    <div class="fastGrid">
                        <a *ngFor="let item of jsonData.fastChannels" [routerLink]="item.url"
                            [class]="'channelTile ' + item.id" (click)="onClose()">
                            <img [src]="item.logo" alt="">
                        </a>

                        <span *ngFor="let item of jsonData.svodChannels" class="channelTile">
                            <a *ngIf="item.external" [href]="item.url" target="_blank" [class]="' ' + item.id"
                                (click)="onClose()">
                                <img [src]="item.logo" alt="">
                            </a>
                            <a *ngIf="!item.external" [routerLink]="item.url" [class]="' ' + item.id"
                                (click)="onClose()">
                                <img [src]="item.logo" alt="">
                            </a>

                        </span>
                    </div>
                </div>

                <!-- Right: SVOD + Digitnet -->
                <!-- <div class="rightSection"> -->
                <!-- <div class="svodSection">
                        <div class="sectionTitle">SVOD Channels</div>
                        <div class="svodGrid">
                            <span *ngFor="let item of jsonData.svodChannels">
                                <a *ngIf="item.external"
                                   [href]="item.url"
                                   target="_blank"
                                   [class]="'channelTile ' + item.id"
                                   (click)="onClose()">
                                    <img [src]="item.logo" alt="">
                                </a>
                                <a *ngIf="!item.external"
                                   [routerLink]="item.url"
                                   [class]="'channelTile ' + item.id"
                                   (click)="onClose()">
                                    <img [src]="item.logo" alt="">
                                </a>

                            </span>
                        </div>
                    </div> -->

                <!-- <div class="sectionDivider"></div> -->

                <!-- <div class="digitnetSection">
                        <div class="sectionTitle">Digitnet Channel</div>
                        <div class="digitnetGrid">
                            <a *ngFor="let item of jsonData.digitnetChannels"
                               [href]="item.url"
                               target="_blank"
                               [class]="'channelTile ' + item.id"
                               (click)="onClose()">
                                <img [src]="item.logo" alt="">
                            </a>
                        </div>
                    </div> -->
                <!-- </div> -->
            </div>

            <!-- Bottom: FAST Series Channels -->
            <div class="seriesSection">
                <div class="topSectionDivider"></div>
                <div class="sectionTitle">Series Channels</div>
                <div class="seriesGrid">
                    <a *ngFor="let item of jsonData.series" [routerLink]="item.url" [class]="'seriesTile ' + item.id"
                        (click)="onClose()">
                        <img [src]="item.logo" alt="">
                    </a>
                </div>
                <div class="dropdownWtwRow" *ngIf="isMobile">
                    <a routerLink="/where-to-watch" class="dropdownWtwLink" (click)="onClose()">Where To Watch</a>
                </div>
            </div>

        </div>
    </div>
</div>